<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M9.16634 6.66659C9.16634 6.20635 9.53942 5.83325 9.99967 5.83325C10.4599 5.83325 10.833 6.20635 10.833 6.66659V9.16658H13.333C13.7933 9.16658 14.1663 9.53967 14.1663 9.99992C14.1663 10.4602 13.7933 10.8333 13.333 10.8333H10.833V13.3333C10.833 13.7935 10.4599 14.1666 9.99967 14.1666C9.53942 14.1666 9.16634 13.7935 9.16634 13.3333V10.8333H6.66634C6.2061 10.8333 5.83301 10.4602 5.83301 9.99992C5.83301 9.53967 6.20611 9.16658 6.66634 9.16658H9.16634V6.66659Z"
      fill="url(#paint0_linear_139_36168)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.1663 9.99992C19.1663 15.0625 15.0623 19.1666 9.99967 19.1666C4.93707 19.1666 0.833008 15.0625 0.833008 9.99992C0.833008 4.93731 4.93707 0.833252 9.99967 0.833252C15.0623 0.833252 19.1663 4.93731 19.1663 9.99992ZM2.50537 9.99992C2.50537 14.1389 5.86068 17.4943 9.99967 17.4943C14.1387 17.4943 17.494 14.1389 17.494 9.99992C17.494 5.86093 14.1387 2.50561 9.99967 2.50561C5.86068 2.50561 2.50537 5.86093 2.50537 9.99992Z"
      fill="url(#paint1_linear_139_36168)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_139_36168"
        x1="5.83301"
        y1="5.83325"
        x2="14.1947"
        y2="14.138"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_139_36168"
        x1="0.833008"
        y1="0.833252"
        x2="19.2287"
        y2="19.1038"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
    </defs>
  </svg>
</template>
